import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { AgentConfig } from "@/types";

// Sub-Resource: 3-Layer Config pro Agent.
// QueryKey: ["resources","agents",id,"config"] — invalidiert sich mit
// Parent-Detail (siehe M3-Pattern, aber ohne list/detail-Split weil es
// genau ein Config-Objekt pro Agent gibt).

export function useAgentConfig(agentId: string | undefined): UseQueryResult<AgentConfig> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: agentId
      ? queryKeys.subResource("agents", agentId, "config")
      : ["resources", "agents", "_invalid", "config"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<AgentConfig>(`/agents/${agentId}/config`);
    },
    enabled: !!agentId && !!session,
  });
}
